var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg_col_fff bor_rad_8 box_sha_0_0_8_8_black_80_per p_16 m_0_16 m_t_16"},[_c('div',{staticClass:"flex_1 font_16 font_bold"},[_vm._v("进件转化")]),(!_vm.loading)?_c('Chart',{staticClass:"h_88_vw m_t_8",attrs:{"options":_vm.options}}):_c('div',{staticClass:"dis_flex ju_con_cen"},[_c('van-loading',{attrs:{"type":"spinner"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }